import { createTrackingEvent } from '@/common/analytics/gtm/createTrackingEvent';
import { NotifyMeMetadataProps } from '@/common/components/NotifyButton/NotifyButton.interface';
import { HomepageAuthor } from 'generatedBfw/static';

type NotifyEventType = 'notify_me' | 'do_not_notify_me';
type NotifyEventFirstTimeType = 'yes' | 'no' | 'unknown';

export interface NotifyCurrentEventProps {
  type: NotifyEventType;
  userActionType: string;
  firstTime: NotifyEventFirstTimeType;
  notifyCounter?: string;
}

interface NotifyEventProps extends Record<string, unknown> {
  event: string;
  notify_me_location: string;
  notify_me_id: string;
  notify_me_name: string;
  notify_me_event_type: string;
  notify_counter?: string;
  notify_me_first_time?: string;
}

export const trackNotifyEvent = (
  metadata: NotifyMeMetadataProps,
  currentEvent: NotifyCurrentEventProps,
) => {
  const preparedEvent: NotifyEventProps = {
    event: currentEvent.type,
    notify_me_location: metadata.componentName,
    notify_me_id: metadata.id,
    notify_me_name: metadata.name,
    notify_me_event_type: currentEvent.userActionType,
    notify_me_first_time: currentEvent.firstTime || '',
  };
  currentEvent.notifyCounter && (preparedEvent.notify_counter = currentEvent.notifyCounter);

  return createTrackingEvent(preparedEvent);
};

export const createNotifyEventName = (title: string, author?: HomepageAuthor) => {
  return `${author ? author.name : 'NA'}|${title}`;
};

interface SetNotifyCounterProps {
  type: 'increment' | 'decrement';
  counter?: number;
}

export const setNotifyCounter = ({ counter, type }: SetNotifyCounterProps): string => {
  if (type === 'increment') return ((counter || 0) + 1).toString();
  return ((counter || 1) - 1).toString();
};
